import { getDeviceId, setItem, USER_TYPE } from "utils/localStorage";
import { getChannelFromUrl, getDeviceType, gotoUrl } from "utils/helpers";
import authenticateUserAndSaveToken from "services/userAuthenticate";
import {
  storeSocialLoginData,
  storeSocialMultipleEmails,
  setData
} from "ducks/actions";
import { publicPaths, SOCIAL_MEDIA_TYPES } from "utils/constants";
import { useDispatch } from "react-redux";
import useAuthorizedUserRedirection from "./useAuthorizedUserRedirection";

const useSocialAuthUserServiceHandler = (
  channel,
  onFailureRedirectUrl,
  redirectChannel
) => {
  const dispatch = useDispatch();
  const redirectUser = useAuthorizedUserRedirection(redirectChannel);

  const callUserServiceLoginApi = socialAuthData => {
    const additionalHeaders = {};
    const bodyParams = {
      device: {
        device_id: getDeviceId(),
        device_type: getDeviceType(),
        app_type: "ecosystem"
      },
      social_auth: socialAuthData
    };
    const onComplete = (result, errors, errorBody) => {
      // if there is a error redirect to previous route, otherwise call handleUserServiceResponse method
      if (errors) {
        if (onFailureRedirectUrl) gotoUrl(onFailureRedirectUrl);
      } else {
        setItem(USER_TYPE, socialAuthData.provider);
        handleUserServiceResponse(result, errors, socialAuthData);
      }
    };

    authenticateUserAndSaveToken(
      additionalHeaders,
      bodyParams,
      onComplete,
      dispatch
    );
  };

  const redirectToRoute = (path, queryParam) => {
    gotoUrl(
      path.replace(
        ":channel",
        redirectChannel ? redirectChannel : getChannelFromUrl
      ),
      false,
      null,
      false,
      queryParam
    );
  };

  const handleUserServiceResponse = (result, errors, socialAuthData) => {
    const EMAIL_RETRIEVE_FAIL_CODE = 200104;
    const MULTIPLE_EMAIL_RETRIEVE_CODE = 200112;
    const { code: statusCode, auth_token, email_adrs, au_line_count } =
      result || {};

    if (socialAuthData.provider === SOCIAL_MEDIA_TYPES.AU_LOGIN) {
      if (auth_token) {
        redirectUser(result, errors, channel);
      } else if (au_line_count === 1) {
        dispatch(storeSocialMultipleEmails({ email_adrs }));
        dispatch(storeSocialLoginData(socialAuthData));
        dispatch(
          setData({
            key: "userLostServiceData",
            data: { userConfirmLostService: false, onFailureRedirectUrl }
          })
        );
        redirectToRoute(publicPaths.AU_LOST_SERVICE_USER_CONFIRM);
      } else {
        dispatch(storeSocialMultipleEmails({ email_adrs }));
        dispatch(storeSocialLoginData(socialAuthData, onFailureRedirectUrl));
        redirectToRoute(publicPaths.SELECT_EMAIL);
      }
    } else {
      //handling the social media auth response except AU
      if (statusCode === EMAIL_RETRIEVE_FAIL_CODE) {
        // redirects to collect email and continue login flow
        dispatch(storeSocialLoginData(socialAuthData));
        redirectToRoute(publicPaths.CONFIRM_EMAIL, { isSocialLogin: true });
      } else if (statusCode === MULTIPLE_EMAIL_RETRIEVE_CODE) {
        // redirects to select a email and continue login flow
        const { metadata: emailList } = result;
        dispatch(storeSocialLoginData(socialAuthData));
        dispatch(storeSocialMultipleEmails(emailList));
        redirectToRoute(publicPaths.SELECT_EMAIL, { continueWithoutOtp: true });
      } else redirectUser(result, errors, channel);
    }
  };

  return socialAuthData => callUserServiceLoginApi(socialAuthData);
};

export default useSocialAuthUserServiceHandler;
